import { buildProps } from '@xzx-design/utils'

import type { ExtractPropTypes } from 'vue-demi' // test vue-demi
import type Button from './button.vue'

export const buttonProps = buildProps({
  type: {
    type: String,
    default: '',
  },
  size: {
    type: String,
    default: '',
  },
  round: {
    type: Boolean,
    default: false,
  },
  circle: {
    type: Boolean,
    default: false,
  },
  plain: {
    type: Boolean,
    default: false,
  },
  block: {
    type: Boolean,
    default: false,
  },
  dashed: {
    type: Boolean,
    default: false,
  },
  text: {
    type: [Boolean, String],
    default: false,
  },
  bg: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  throttle: {
    type: [Boolean, Number],
    default: false,
  },
  icon: {
    type: [String, Object],
    default: '',
  },
  formSubmit: {
    type: Boolean,
    default: false,
  },
})

export const buttonEmits = {
  click: (e?: Event) => e as any,
}

export type ButtonProps = ExtractPropTypes<typeof buttonProps>
export type ButtonEmits = typeof buttonEmits
export type ButtonInstance = InstanceType<typeof Button>
